import React, { Component } from "react";
import PropTypes from "prop-types";
import assign from "lodash/assign";
import get from "lodash/get";
import Label from "./Label";
import IconButton from "components/IconButton";
import { valueFormatter } from "./helpers";
import { AUTO_ATTRS, AMOUNT, BUTTON_HOVER_COLORS } from "./constants";

const DEFAULT_CLASSES = {
  container: "w-100",
  input: "border-box input-reset ba pa2 mb2 db w-100 br2 lh-copy"
};
const TEXT_TYPE = "text";

class Input extends Component {
  constructor() {
    super();
    this._component = null;
    this.asFixed = this.asFixed.bind(this);
  }

  stageActionButton() {
    const { disabled, onChange, component, stage, stateKey } = this.props;
    const actionProps = {
      disabled,
      onClick: () => {
        if (onChange) {
          const stageVal = this.asFixed(stateKey, stage);
          onChange(stateKey, component)(stageVal);
        } else if (this._component && !disabled) {
          this._component.value = stage;
        } else {
          console.log("** No ability to use stage");
        }
      },
      iconType: "magic",
      customClasses: {
        button: "ma0 bg-white pointer br2 ba br2 bw1 b--black-30 mb2 br--right"
      },
      colors: BUTTON_HOVER_COLORS
    };

    return <IconButton {...actionProps} />;
  }

  asFixed(key, value) {
    return key === AMOUNT ? parseFloat(value / 100).toFixed(2) : value;
  }

  stageComp() {
    const { stage, customClasses, type, stateKey } = this.props;
    const classes = assign({}, DEFAULT_CLASSES, customClasses);
    const stageVal = this.asFixed(stateKey, stage);
    const stageInput = {
      "key": "stage-input",
      "disabled": true,
      "value": stageVal,
      "className": `${classes.input} br--left`,
      "type": type || TEXT_TYPE,
      "aria-describedby": "label-desc",
      ...AUTO_ATTRS
    };

    return (
      <div key={`${stateKey}-stage`} className="flex flex-row">
        <input {...stageInput} />
        {this.stageActionButton()}
      </div>
    );
  }

  render() {
    const {
      label,
      type,
      value,
      stage,
      disabled,
      customClasses,
      defaultValue,
      placeholder,
      stateKey,
      component,
      validation,
      format,
      setRef,
      onChange,
      onKeyPress
    } = this.props;
    const classes = assign({}, DEFAULT_CLASSES, customClasses);
    const formattedValue = valueFormatter(format, value || defaultValue);
    const hasError = Boolean(get(validation, "error", false));
    classes.input += hasError
      ? " b--red"
      : disabled
      ? " hairline-1"
      : " b--black-20";

    const inputProps = {
      "id": label,
      disabled,
      "name": stateKey,
      placeholder,
      onKeyPress,
      "className": classes.input,
      "type": type || TEXT_TYPE,
      "aria-describedby": "label-desc",
      ...AUTO_ATTRS,
      "ref": (inputComp) => {
        this._component = inputComp;
      }
    };

    if (onChange) {
      inputProps.value = formattedValue;
      inputProps.onChange = onChange(stateKey, component);
    } else {
      inputProps.defaultValue = formattedValue;
    }

    if (setRef) {
      inputProps.ref = (comp) => {
        setRef(stateKey, comp);
      };
    }

    let labelComp;
    if (label) {
      const labelProps = {
        label,
        error: hasError,
        key: "input-label"
      };
      labelComp = <Label {...labelProps} />;
    }

    const inputComps = [<input key={stateKey} {...inputProps} />];
    if (
      stage &&
      `${inputProps.value}`.toLowerCase() !== `${stage}`.toLowerCase()
    ) {
      inputComps.push(this.stageComp());
    }
    // console.log('KEY: %s STAGE VAL: %s ', stateKey, stage)

    return (
      <div className={classes.container}>
        {labelComp}
        {inputComps}
      </div>
    );
  }
}

Input.propTypes = {
  label: PropTypes.string,
  stateKey: PropTypes.string,
  component: PropTypes.string,
  format: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.node,
  stage: PropTypes.any,
  defaultValue: PropTypes.node,
  placeholder: PropTypes.node,
  validation: PropTypes.object,
  disabled: PropTypes.bool,
  customClasses: PropTypes.object,
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  onKeyPress: PropTypes.func
};

Input.defaultProps = {
  defaultValue: "",
  customClasses: {},
  validation: {},
  onKeyPress: () => {}
  // onChange: (key, component) => {
  //   return (evt) => {
  //     console.log('**** Input type', evt.currentTarget.value)
  //   }
  // }
};

export default Input;
